import { jsx as _jsx } from "react/jsx-runtime";
import { cn } from 'hx-util';
export function GradientDivider(_a) {
    var className = _a.className;
    var dividerClass = cn('rounded-xl h-1 bg-[linear-gradient(to_right,#FB9C84,#E499B1,#80D6D0,#717BFF)]', className);
    return _jsx("div", { className: dividerClass });
}
